import { Theme, makeStyles, createStyles } from "@material-ui/core";

export const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    root: {
      display: "flex",
      gap: theme.spacing(2),
    },
    controls: {
      display: "flex",
      flexDirection: "column",
      gap: theme.spacing(2),
    },
    frequencyOptions: {
      fontSize: "12px",
    },
    frequencyOptionLabel: {
      "& span": {
        fontSize: "12px",
      },
    },
    frequencyOptionControl: {
      fontSize: "12px",
      "& svg": {
        fill: "#65ac1f",
      },
    },
  })
);
